import Vue from 'vue';
// eslint-disable-next-line
export const auditLogsEventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/admin/auditLogs/auditLogsEventBus.js